import { createSelector } from 'reselect';
import lodash from 'lodash';

import getMenu from './getMenu';

export default createSelector(
  [getMenu],
  orderMenu => lodash.get(orderMenu, 'boostIngredients') || undefined,
);
